import { Upload as AntUpload, UploadProps } from "antd";
import { forwardRef, memo } from "react";
import useModalNotification from "../../hook/use-modal-notification";

export interface IUploadProps extends UploadProps {
  maxSizePerFile?: number | false; // set size of file,if maxSizePerFile === false is infinity size
  maxSize?: number | false; // set total size of files, if maxSize === false is infinity size
  upload?: boolean;
}

const fncFallback = () => {};

const Upload = forwardRef((props: IUploadProps, ref) => {
  const {
    upload = true,
    beforeUpload: beforeUploadCb = fncFallback,
    children,
    maxSizePerFile = false,
    maxSize = false,
    ...restProps
  } = props;
  const { showError, ModalNotificationComponent } = useModalNotification();

  return (
    <>
      <AntUpload
        {...restProps}
        ref={ref}
        beforeUpload={(file, fileList) => {
          const fileListSize = fileList.reduce((acc, cur) => acc + cur.size, 0);
          const fileListSizeExceeded = typeof maxSize === "number" && fileListSize > maxSize;
          const fileSizeExceeded = typeof maxSizePerFile === "number" && file.size > maxSizePerFile;

          if (fileSizeExceeded) {
            showError(`Tệp ${file.name} quá lớn`);
            return AntUpload.LIST_IGNORE;
          }
          if (fileListSizeExceeded) {
            showError(`Tệp quá lớn`);
            return AntUpload.LIST_IGNORE;
          }
          if (!upload) return false;
          beforeUploadCb(file, fileList);
        }}
      >
        {children}
      </AntUpload>
      {ModalNotificationComponent}
    </>
  );
});

export default memo(Upload);
